import { Link } from 'react-router-dom';
import type { Device } from '../../../types/device';
import { formatRelativeTime } from '../../../utils/formatters';

export interface AdminDeviceSearchResultRowProps {
  device: Device;
  onSelect?: (device: Device) => void;
  showOpenLink?: boolean;
}

/** One row in device lookup results — pick for a form or open full admin record. */
export function AdminDeviceSearchResultRow({
  device,
  onSelect,
  showOpenLink = true,
}: AdminDeviceSearchResultRowProps) {
  const label = device.name || device.serial_number;
  const owner = device.user?.name || device.user?.email;

  const body = (
    <>
      <div className="font-mono text-sm text-cyan-300">{device.id}</div>
      <div className="text-sm text-white truncate">{label}</div>
      <div className="text-xs text-slate-400 truncate">
        {device.serial_number}
        {owner ? ` · ${owner}` : ''}
        {device.last_seen_at ? ` · seen ${formatRelativeTime(device.last_seen_at)}` : ''}
      </div>
    </>
  );

  if (onSelect) {
    return (
      <button
        type="button"
        onClick={() => onSelect(device)}
        className="w-full text-left px-3 py-2 rounded-lg hover:bg-slate-700/80 border border-transparent hover:border-slate-600 transition-colors"
      >
        {body}
      </button>
    );
  }

  return (
    <div className="px-3 py-2 rounded-lg border border-slate-700/50 bg-slate-900/40">
      {body}
      {showOpenLink && (
        <Link
          to={`/admin/devices/${device.id}`}
          className="text-xs text-cyan-500 hover:text-cyan-300 mt-1 inline-block"
        >
          Open device record →
        </Link>
      )}
    </div>
  );
}
